module.exports = __webpack_public_path__ + "static/media/gnt.57e9acfc.png";